/**
 * Business logic per Cross Company Job Activities autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import crossCompanyMirrorConfigsService from '../services/crossCompanyMirrorConfigsService';
import type { AutocompleteResult, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export interface CrossCompanyTargetJobActivitiesOptions {
	targetCompany: string;
	searchString?: string;
	id?: number | string | null;
	notInIds?: Array<number | string> | null;
	orderId?: number | string | null;
}

export async function getCrossCompanyTargetJobActivitiesAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: CrossCompanyTargetJobActivitiesOptions,
): Promise<AutocompleteResult[]> {
	const { targetCompany, searchString = '', id = null, notInIds = null, orderId = null } = options;

	const context: ODataContext = {
		select: 'id,code,description',
		top: 20,
		orderBy: ['code'],
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(description)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [
				{
					id: {
						in: notInIds,
					},
				},
			],
		});
	}

	if (orderId) {
		context.filter!.and!.push({
			orders: {
				any: {
					jobOrderId: orderId,
				},
			},
		});
	}

	const result = await crossCompanyMirrorConfigsService.getCrossCompanyJobActivities(
		targetCompany,
		buildQuery(context),
	);
	return result;
}
